//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import account from './components/account.vue';
export default {
  components: {
    account,
  },
  data() {
    return {
      redirectUrl: '',
      storage: true,
      fromUrl: '',
    };
  },
  computed: {},
  watch: {},
  mounted() {
    const storage = Number(this.$route.query.storage);
    console.log('------storage------', storage);
    this.fromUrl = this.$route.query.from_url;
    console.log('------fromUrl------', this.fromUrl);
    if (storage === 0) {
      this.storage = false;
    } else {
      this.storage = true;
    }

    console.log('------this.storage------', this.storage);
  },
};
